import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { ROLE_OPTIONS } from 'Auth/permissions';

/**
 * Confirmation dialog for changing a user's role (C2D-991). Changing a role previously fired
 * on a single click of a small tooltip-only icon, so it was both easy to miss and easy to
 * trigger by accident; this makes the action deliberate.
 */
const RoleChangeModal = (props) => {
  const [fetchingData, setFetchingData] = useState(false);
  const pending = props.userPendingRoleChange || {};
  const user = pending.user || {};
  const currentRole = String(user.role || 'USER').toUpperCase();
  const [role, setRole] = useState(currentRole);

  useEffect(() => {
    if (props.show) setRole(currentRole);
  }, [props.show, currentRole]);

  const selected = ROLE_OPTIONS.find((o) => o.value === role) || {};

  return (
    <Modal onHide={() => props.handleClose()} show={props.show}>
      <Modal.Header closeButton>
        Change role
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Role for <strong>{user.email}</strong></Form.Label>
          <Form.Control
            as='select'
            value={role}
            data-testid='role-change-select'
            onChange={(e) => setRole(e.target.value)}
          >
            {ROLE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </Form.Control>
          <Form.Text className='text-muted'>{selected.description}</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className='d-flex flex-nowrap'>
        <div className='w-50'>
          <Button
            className='mr-2 pr-3 pl-3 w-100'
            variant='outline-secondary'
            onClick={() => props.handleClose()}
          >
            CANCEL
          </Button>
        </div>
        <div className='w-50'>
          <Button
            disabled={fetchingData || role === currentRole}
            className='pr-3 pl-3 w-100'
            variant={currentRole === 'ADMIN' ? 'danger' : 'primary'}
            type='button'
            data-testid='role-change-confirm'
            onClick={async () => {
              setFetchingData(true);
              await props.handleConfirm(user, role);
              setFetchingData(false);
              props.handleClose();
            }}
          >
            {fetchingData && (
              <Spinner className='mr-2' as='span' animation='border' size='sm' role='status' aria-hidden='true' />
            )}
            CHANGE ROLE
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleChangeModal;
